import { IRoleTypeService } from "../../service/role/RoleTypeService";

export default class GetRoleTypeReportingTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleTypeCode: string) {
    return this.roleTypeService.getRoleTypeReportingTypes(roleTypeCode);
  }
}
